<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content" *ngIf="!pageLoading">
    <h3 i18n='New contact heading for contact modal@@customerOverviewComponent.modalTitle.editReminder'>Edit Reminder</h3>
    <form (ngSubmit)="updateReminder()" [formGroup]="updateReminderForm" id="updateReminderForm">
      <div app-form-field-textarea
           [control]="updateReminderForm.get('text')"
           [label]="reminderTranslations.i18nComment">
      </div>
      <div app-form-field-datepicker
           [future]="true"
           [control]="updateReminderForm.get('deadline')"
           [placeholder]="reminderTranslations.i18nDeadline"
           [label]="reminderTranslations.i18nDeadline">
      </div>
      <div app-form-field-select
           [control]="updateReminderForm.get('status')"
           [label]="flTranslations.i18nStatus"
           [array]="availableStatuses"
           [preselectedValue]="preselectedValue">
      </div>
      <div app-form-field-select
           [control]="updateReminderForm.get('owner')"
           [label]="flTranslations.i18nOwner"
           [textKey]="'fullName'"
           [valueKey]="'id'"
           [array]="possibleOwnersList">
      </div>
    </form>
    <div class="esf-submit-row__item" *ngIf="!attachmentLoading && this.currentReminder.attachment">
      <button class="esf-button esf-button--simple"
              (click)="downloadAttachment()"
              [disabled]="currentReminder.attachment == null">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-download"></use>
        </svg>
        <span class="esf-button__icon-text">{{ file?.originalName }}</span>
      </button>
    </div>
    <div class="esf-main-sidebar__content">
      <app-spinner [name]="spinnerAttachmentLoadName" [(show)]="attachmentLoading"></app-spinner>
    </div>
  </div>
  <div class="esf-main-sidebar__content">
    <app-spinner [name]="spinnerPageLoadName" [(show)]="pageLoading"></app-spinner>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="'updateReminderForm'"
                          [isFieldValid]="!customer.isDuplicate"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition -is-open"
     (click)="customerOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
